import React, { use, useState } from "react";

import usePrivileges from "../../../../Auth/usePrivileges";
import { LotDetailContext } from "../../../../Contexts/LotDetailContext";
import SetLotStatusDialog from "../../../../Dialogs/SetLotStatusDialog";
import { LotStatusControl, ProcessingStatusControl } from "../LotStatusControls";

export function LotProcessingStateFields() {
    const {
        lotDetail: {
            summary: {
                businessUnitCode
            }
        },
    } = use(LotDetailContext);

    const { admin } = usePrivileges(businessUnitCode);
    const [showSetLotStatusDialog, setShowSetLotStatusDialog] = useState(false);

    return (
        <>
            <LotStatusControl setShowSetLotStatusDialog={setShowSetLotStatusDialog} />
            <ProcessingStatusControl setShowSetLotStatusDialog={setShowSetLotStatusDialog} />
            <SetLotStatusDialog showDialog={admin && showSetLotStatusDialog} closeDialog={() => setShowSetLotStatusDialog(false)} />
        </>
    );
}